import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdvisoryComponent } from './advisory/advisory.component';
import { ProjectComponent } from './project/project.component';
import { ArchitectureComponent } from './architecture/architecture.component';
import { ConsultingComponent } from './consulting/consulting.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [AdvisoryComponent, ProjectComponent, ArchitectureComponent, ConsultingComponent],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule
  ]
})
export class ConsultingModule { }
